import { FormattedMessage } from "react-intl";
import { CreateUser } from "../components/UserComponents/CreateUser";
import { CreateCustomer } from "../components/CustomerComponents/CreateCustomer";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import StoreIcon from '@mui/icons-material/Store';

export const Routes = [
    {
        path: "/",
        name:
            <FormattedMessage
                id="navbar.home"
                defaultMessage="Inicio"
            />
    },
    {
        path: "/createuser",
        name:
            <>
                <PersonAddIcon /> <FormattedMessage id="navbar.create.user" defaultMessage="Crear usuarios" />
            </>,
        protected: true,
        role: 1,
        component: <CreateUser />
    },
    {
        path: "/createcustomer",
        name: <><StoreIcon /> Crear cliente</>,
        protected: true,
        role: 1,
        component: <CreateCustomer />
    }
];